export default "__VITE_ASSET__DnTRk9QA__"